const translations = {
  "en": {
    "Answers from your real numbers. Unlock full access.": "Answers from your real numbers. Unlock full access.",
    "Coming soon, please choose other ways.": "Coming soon, please choose other ways.",
    "Flag risks before they land": "Flag risks before they land",
    "Link an account and I'll answer with your actual data.": "Link an account and I'll answer with your actual data.",
    "Net worth, spending and accounts in one place": "Net worth, spending and accounts in one place",
    "Track holdings, prices and returns in real time": "Track holdings, prices and returns in real time"
  },
  "zh-tw": {
    "Answers from your real numbers. Unlock full access.": "答案源自你的真實數字。解鎖完整權限。",
    "Coming soon, please choose other ways.": "即將推出，請選擇其他方式。",
    "Flag risks before they land": "在風險發生前預先警示",
    "Link an account and I'll answer with your actual data.": "連結帳戶，我將以你的實際資料為你解答。",
    "Net worth, spending and accounts in one place": "淨資產、支出與帳戶，一處掌握",
    "Track holdings, prices and returns in real time": "即時追蹤持倉、價格與報酬"
  }
};

export default translations;
